import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import Portfolio from './components/Portfolio';
import Philosophy from './components/Philosophy';
import Protocol from './components/Protocol';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

function App() {
  return (
    <div className="bg-background text-dark min-h-screen font-subheading selection:bg-accent selection:text-background">
      <Navbar />
      <main>
        <Hero />
        <Features />
        <Portfolio />
        <Philosophy />
        <Protocol />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
